import { Card, CardContent } from "@/components/ui/card";

// Sprint 56 — refined statcard: subtle gradient background, hover lift,
// larger display value, and a rail accent per tone.
export default function StatCard({ label, value, hint, icon: Icon, tone = "primary", testId, trend }) {
  const toneMap = {
    primary: { chip: "bg-primary/10 text-primary", rail: "bg-primary" },
    accent:  { chip: "bg-accent/10 text-accent",   rail: "bg-accent" },
    warn:    { chip: "bg-amber-500/10 text-amber-600", rail: "bg-amber-500" },
    danger:  { chip: "bg-destructive/10 text-destructive", rail: "bg-destructive" },
    muted:   { chip: "bg-secondary text-secondary-foreground", rail: "bg-muted-foreground/40" },
  };
  const t = toneMap[tone] || toneMap.primary;
  return (
    <Card
      className="relative overflow-hidden border-border/60 bg-gradient-to-br from-card via-card to-secondary/30 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
      data-testid={testId}
    >
      <div className={`absolute top-0 left-0 h-full w-[3px] ${t.rail} opacity-70`} aria-hidden="true" />
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold">{label}</div>
            <div className="text-[26px] md:text-[30px] font-display font-bold mt-1.5 truncate leading-tight tracking-tight">{value}</div>
            {hint && (
              <div className="text-[11px] text-muted-foreground mt-1.5 flex items-center gap-1 truncate">
                {trend && (
                  <span className={`inline-block text-[10px] font-bold px-1.5 py-0.5 rounded ${trend > 0 ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>
                    {trend > 0 ? "▲" : "▼"} {Math.abs(trend)}%
                  </span>
                )}
                <span className="truncate">{hint}</span>
              </div>
            )}
          </div>
          {Icon && (
            <div className={`w-11 h-11 rounded-xl grid place-items-center shrink-0 ${t.chip}`}>
              <Icon className="w-5 h-5" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
